/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ExportFileType {
    COMPOSITES = 'composites',
    COMPOSITE_REPORT = 'compositeReport',
    COMPOSITE_DETAILS_REPORT = 'compositeDetailsReport',
    CUT_DETAILS_REPORT = 'cutDetailsReport',
    CUT_SELECTIONS_REPORT = 'cutSelectionsReport',
    SURVEY_DATA_REPORT = 'surveyDataReport',
    SURVEY_PARTICIPATION = 'surveyParticipation',
    SURVEY_PARTICIPATION_CSV = 'surveyParticipationCSV',
    SALARY_RANGE = 'salaryRange',
    RANGE_ASSIGNMENTS = 'rangeAssignments',
    RANGE_NAMES = 'rangeNames',
    DATA_MODEL = 'dataModel',
    DATA_MODEL_COMPOSITES = 'dataModelComposites',
    DATA_MODEL_RANGE_NAMES = 'dataModelRangeNames',
    DATA_MODEL_RANGE_ASSIGNMENTS = 'dataModelRangeAssignments',
    COMPANY_LEVELS = 'companyLevels',
    COMPANY_JOB_FAMILY = 'companyJobFamily',
    EMPLOYEE_DATA = 'employeeData',
    PAYMARKETS = 'paymarkets',
    PERCENTILE = 'percentile',
    SURVEY_REPLACEMENT_SUMMARY_REPORT = 'surveyReplacementSummaryReport',
    RANGE_ZONES = 'rangeZones',
    DATA_MODEL_RANGE_ZONES = 'dataModelRangeZones',
    RANGE_GROUPS = 'rangeGroups',
    DATA_MODEL_RANGE_GROUPS = 'dataModelRangeGroups',
}
